import React, {useState} from 'react';
import styles from "./LogsTable.module.css"
import {reportFieldLabels} from "../../../types/report.consts";
import {ReportData} from "../../../types/report.types";
import {useFetchReportsLogs} from "../../../hooks/useQuery/useFetchReportsLogs";
import {LoadingErrorBlock} from "../../shared/LoadingErrorBlock";
import {ReportFieldLabelsType} from "../../../services/models/report";
import {Pagination} from "../../shared/Pagination/Pagination";
import {getWeekDateRange} from "../../../Utils/translateDate";

interface LogsTableProps {
    isAdmin: boolean;
    reportData?: ReportData;
    onDataChange?: (data: ReportData) => void;
}

const limit = 10;
const getIndicatorLabel = (labels: ReportFieldLabelsType, section: "resultPO" | "resultPOChildren", indicator: string): string => {
    try {
        if (section === "resultPO") {
            const sectionLabels = labels.resultPO;
            return sectionLabels[indicator as keyof typeof sectionLabels] || indicator;
        } else if (section === "resultPOChildren") {
            const sectionLabels = labels.resultPOChildren;
            return sectionLabels[indicator as keyof typeof sectionLabels] || indicator;
        }
        return indicator;
    } catch (e) {
        console.error('Error getting indicator label:', e);
        return indicator;
    }
};

export const LogsTable: React.FC<LogsTableProps> = () => {

    const [page, setPage] = useState(1)

    const {reportsLogsData, reportsLogsMeta, reportsLogsError, reportsLogsIsLoading} = useFetchReportsLogs(page, limit)

    if (!reportsLogsData || reportsLogsData.length === 0) {
        return (
            <div className={styles.emptyState}>
                <p className={styles.emptyMessage}>
                    Изменений в отчетах пока не было
                </p>
            </div>
        );
    }
    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    return (
        <>
            <LoadingErrorBlock
                isLoading={reportsLogsIsLoading}
                isError={Boolean(reportsLogsError)}
                errorMessage={"Ошибка загрузки логов отчетов. Пожалуйста, попробуйте позже."}
            />
            <div className={styles.tableWrapper}>
                <div className={`${styles.table} ${styles.tableOP}`}>
                    <div className={styles.tableBody}>
                        <div className={styles.rowHead}>
                            <div className={styles.col}>Дата и время</div>
                            <div className={styles.col}>Пользователь</div>
                            <div className={styles.col}>Период</div>
                            <div className={styles.col}>Показатель</div>
                            <div className={styles.col}>Старое значение</div>
                            <div className={styles.col}>Новое значение</div>
                        </div>
                        {reportsLogsData.map(log => (
                            <div key={log._id} className={styles.row}>
                                <div className={styles.col}>
                                    {log.formattedDate}
                                </div>
                                <div className={styles.col}>
                                    {log.userFullName}
                                </div>
                                <div className={styles.col}>
                                    {getWeekDateRange(log.reportingWeek, log.reportingYear)}
                                </div>
                                <div className={styles.col}>
                                    {getIndicatorLabel(reportFieldLabels, log.section, log.indicator)}
                                </div>
                                <div className={styles.col}>
                                    {log.oldValue}
                                </div>
                                <div className={styles.col}>
                                    {log.newValue}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {reportsLogsMeta && reportsLogsMeta.totalPages && reportsLogsMeta.totalPages > 1 && (
                <Pagination
                    currentPage={reportsLogsMeta.currentPage || 1}
                    totalPages={reportsLogsMeta.totalPages || 1}
                    onPageChange={handlePageChange}
                />
            )}
        </>
    )
};